import { render } from "./usrinquire_show.vue?vue&type=template&id=18d14a06&scoped=true"
import script from "./usrinquire_show.vue?vue&type=script&lang=js"
export * from "./usrinquire_show.vue?vue&type=script&lang=js"

import "./usrinquire_show.vue?vue&type=style&index=0&id=18d14a06&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d14a06"]])

export default __exports__